var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "25",
        height: "24",
        viewBox: "0 0 25 24",
        fill: "none",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M9.73896 4.56015L9.739 4.56006C9.90509 4.22481 10.2465 4.01562 10.6188 4.01562H14.3813C14.7535 4.01562 15.0949 4.22481 15.261 4.56006L15.261 4.56015L15.486 5.00703L15.4904 5.01562H15.5H18.5C19.0445 5.01562 19.4844 5.4555 19.4844 6C19.4844 6.5445 19.0445 6.98438 18.5 6.98438H6.5C5.9555 6.98438 5.51562 6.5445 5.51562 6C5.51562 5.4555 5.9555 5.01562 6.5 5.01562H9.5H9.50963L9.51396 5.00703L9.73896 4.56015ZM6.51562 8.01562H18.4844V18C18.4844 19.0945 17.5945 19.9844 16.5 19.9844H8.5C7.4055 19.9844 6.51562 19.0945 6.51562 18V8.01562ZM9.5 9.98438C9.21637 9.98438 8.98438 10.2164 8.98438 10.5V17.5C8.98438 17.7836 9.21637 18.0156 9.5 18.0156C9.78363 18.0156 10.0156 17.7836 10.0156 17.5V10.5C10.0156 10.2164 9.78363 9.98438 9.5 9.98438ZM12.5 9.98438C12.2164 9.98438 11.9844 10.2164 11.9844 10.5V17.5C11.9844 17.7836 12.2164 18.0156 12.5 18.0156C12.7836 18.0156 13.0156 17.7836 13.0156 17.5V10.5C13.0156 10.2164 12.7836 9.98438 12.5 9.98438ZM15.5 9.98438C15.2164 9.98438 14.9844 10.2164 14.9844 10.5V17.5C14.9844 17.7836 15.2164 18.0156 15.5 18.0156C15.7836 18.0156 16.0156 17.7836 16.0156 17.5V10.5C16.0156 10.2164 15.7836 9.98438 15.5 9.98438Z",
          fill: "#010A11",
          stroke: "#333333",
          "stroke-width": "0.03125",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }